export function readCookie (name) {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')

  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i]
    c = c.trim()

    if (c.indexOf(nameEQ) === 0) {
      return c.split('=')[1]
    }
  }
  return null
}

export function writeCookie (name, value, options = { expires: 365 }) {
  // calculate the end date for the cookie
  const today = new Date()
  const expireDate = new Date()
  expireDate.setTime(today.getTime() + (3600000 * 24 * options.expires))

  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expireDate.toGMTString()}`
}

export default {
  read: readCookie,
  write: writeCookie
}
